import { Component, component, ComponentPolicy, DateType, property } from '../../../concepts/objects';
import { Audited } from '../auditing/Audited';

const commentDef = {
    name: 'Comment',
    implements: [Audited],
};

@component(commentDef)
export class Comment extends Component implements Audited {

    @property({ type: 'string' })
    public content!: string;

    @property({ type: 'string' })
    public userId!: string;

    @property({ type: 'boolean' })
    public edited!: boolean;

    @property({ type: 'string' })
    public threadKey!: string;

    @property({ type: DateType })
    public created!: Date;

    protected get policy(): ComponentPolicy {
        return ComponentPolicy.restricted('Reaction');
    }

    public toText(): string {
        return this.content;
    }

}
